module.exports = __webpack_public_path__ + "static/media/bracket.c7ada559.svg";